/* Copyright (c) 2017 Backpack Health LLC */
/* eslint-disable no-param-reassign */
import * as _ from 'lodash';

export function date(healthEntryCategoryState) {
  healthEntryCategoryState.date = healthEntryCategoryState.date || { date: '', precision: '' };

  return {
    data: () => healthEntryCategoryState.date,
    date: () => healthEntryCategoryState.date.date,
    precision: () => healthEntryCategoryState.date.precision,
    set: (dateData) => { healthEntryCategoryState.date = dateData; },
    clear: () => { healthEntryCategoryState.date = { date: '', precision: '' }; },
    hasDate: () => healthEntryCategoryState.date.date !== '',
  };
}

export function startDate(healthEntryCategoryState) {
  healthEntryCategoryState.started = healthEntryCategoryState.started || { date: '', precision: '' };

  return {
    data: () => healthEntryCategoryState.started,
    date: () => healthEntryCategoryState.started.date,
    precision: () => healthEntryCategoryState.started.precision,
    set: (dateData) => { healthEntryCategoryState.started = dateData; },
    clear: () => { healthEntryCategoryState.started = { date: '', precision: '' }; },
    hasDate: () => healthEntryCategoryState.started.date !== '',
  };
}

export function endDate(healthEntryCategoryState) {
  healthEntryCategoryState.ended = healthEntryCategoryState.ended || { date: '', precision: '' };

  return {
    data: () => healthEntryCategoryState.ended,
    date: () => healthEntryCategoryState.ended.date,
    precision: () => healthEntryCategoryState.ended.precision,
    set: (dateData) => { healthEntryCategoryState.ended = dateData; },
    clear: () => { healthEntryCategoryState.ended = { date: '', precision: '' }; },
    hasDate: () => healthEntryCategoryState.ended.date !== '',
  };
}

export function cleanStartDate(healthEntryCategoryState) {
  if (_.get(healthEntryCategoryState, 'started.date', '') === '') {
    healthEntryCategoryState.started = null;
  }
  return healthEntryCategoryState;
}

export function cleanEndDate(healthEntryCategoryState) {
  if (_.get(healthEntryCategoryState, 'ended.date', '') === '') {
    healthEntryCategoryState.ended = null;
  }
  return healthEntryCategoryState;
}

export function cleanValueDate(healthEntryValueState) {
  if (_.get(healthEntryValueState, 'date.date', '') === '') {
    _.set(healthEntryValueState, 'date', null);
  }
  return healthEntryValueState;
}
